import {
    FeatureAccess,
    PartnerBoardFeature,
    PartnerBoardFeatureRight,
} from '../store/partnerManagerSlice';

interface Params {
    feature_access?: FeatureAccess[];
}

export function usingFeatureAccess(
    params: Readonly<Params>,
    feature: PartnerBoardFeature,
    level: PartnerBoardFeatureRight
): boolean {
    if (!params?.feature_access) {
        return false;
    }

    const access = params.feature_access.find((it) => it.feature === feature);

    switch (level) {
        case 'FULL_ACCESS':
            return access?.rights === 'FULL_ACCESS';
        case 'READ_ONLY':
            return (
                access?.rights === 'READ_ONLY' ||
                access?.rights === 'FULL_ACCESS'
            );
        default:
            return false;
    }
}

export function usingFeatureReadAccess(
    params: Readonly<Params>,
    feature: PartnerBoardFeature
): boolean {
    return usingFeatureAccess(params, feature, 'READ_ONLY');
}

export function usingFeatureWriteAccess(
    params: Readonly<Params>,
    feature: PartnerBoardFeature
): boolean {
    return usingFeatureAccess(params, feature, 'FULL_ACCESS');
}
